/**
 * French line-plot prompts and data titles (ADR 0084 §5). Same shape as the
 * English file. An X is "une croix"; both marks take "Combien de", so only
 * the noun changes.
 */
/** The mark's `LinePlotMarkOptions` value: 'X' or 'Dot'. */
type Mark = string;

const markWord = (mark: Mark) => (mark === 'Dot' ? 'points' : 'croix');

export const linePlotPrompts = {
    readOne: (value: string, mark: Mark) => `Combien de ${markWord(mark)} y a-t-il au-dessus de ${value} ?`,
    // "sur", not "au-dessus de": with it twice, the sentence wrapped to two
    // lines and eight questions spilled onto a second page (measured).
    difference: (more: string, fewer: string, mark: Mark) =>
        `Combien de ${markWord(mark)} de plus sur ${more} que sur ${fewer} ?`,
    total: (mark: Mark) => `Combien de ${markWord(mark)} y a-t-il en tout ?`,
    mostCommon: () => `Quelle valeur apparaît le plus souvent ?`,
    range: () => `Combien vaut la plus grande valeur moins la plus petite ?`,
    median: () => `Quelle est la médiane des données ?`,
};

export const linePlotContexts: {
    counted: { title: string; start: [number, number] }[];
    measured: { title: string; start: [number, number] }[];
} = {
    counted: [
        { title: 'Livres lus par chaque élève ce mois-ci', start: [0, 4] },
        { title: 'Buts marqués à chaque match', start: [0, 1] },
        { title: 'Lettres dans chaque prénom', start: [2, 4] },
        { title: 'Points marqués à chaque manche', start: [0, 12] },
        { title: 'Pompes faites par chaque élève', start: [5, 12] },
    ],
    measured: [
        { title: 'Longueur des rubans (pouces)', start: [1, 6] },
        { title: 'Longueur des crayons (pouces)', start: [2, 5] },
        { title: 'Longueur des vers de terre (pouces)', start: [1, 3] },
        { title: 'Poids des chiots (livres)', start: [2, 8] },
        { title: "Eau dans chaque bouteille (tasses)", start: [0, 2] },
        { title: 'Distance courue par chaque élève (milles)', start: [0, 3] },
    ],
};
